import { render, staticRenderFns } from "./RoleSearch.vue?vue&type=template&id=48604b4c&scoped=true"
import script from "./RoleSearch.vue?vue&type=script&lang=js"
export * from "./RoleSearch.vue?vue&type=script&lang=js"
import style0 from "./RoleSearch.vue?vue&type=style&index=0&id=48604b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48604b4c",
  null
  
)

export default component.exports